import type { ApiResponse } from "@/types";
import {
  type UseQueryResult,
  queryOptions,
  useQuery,
} from "@tanstack/react-query";
import type { SerializableMcpConnection } from "../../../schemas/codegen";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export function getMcpServersQueryOptions(projectId: string) {
  return queryOptions({
    queryKey: [QUERY_KEYS.MCP_SERVERS, projectId],
    queryFn: () => api.listMcpServers(projectId),
    select: (
      response: ApiResponse<{
        connections: Record<string, SerializableMcpConnection>;
      }>,
    ) => response.data.connections,
  });
}

export function useMcpServers(
  projectId?: string,
): UseQueryResult<Record<string, SerializableMcpConnection>, Error> {
  return useQuery<
    ApiResponse<{ connections: Record<string, SerializableMcpConnection> }>,
    Error,
    Record<string, SerializableMcpConnection>
  >({
    queryKey: [QUERY_KEYS.MCP_SERVERS, projectId],
    queryFn: () => {
      if (!projectId) {
        throw new Error("Project ID is required");
      }
      return api.listMcpServers(projectId);
    },
    enabled: !!projectId,
    select: (response) => response.data.connections,
  });
}
